"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Mission() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: hairlineRef,
    isVisible: hairlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="15269" id="services-cta-section" className="bg-background text-foreground py-40 md:py-56 px-5 md:px-12">
      <div className="mx-auto max-w-[1440px]">
        <div className="grid grid-cols-12 gap-2 md:gap-6">
          <div className="col-span-12 md:col-start-3 md:col-span-8">
            {}
            <div ref={eyebrowRef} className="font-default uppercase mb-6 md:mb-8" style={{
            fontSize: "clamp(0.75rem, 0.85vw, 0.8125rem)",
            fontWeight: 500,
            letterSpacing: "0.08em",
            lineHeight: 1,
            color: "var(--muted-foreground)",
            transform: eyebrowVisible ? "translateY(0)" : "translateY(12px)",
            opacity: eyebrowVisible ? 1 : 0,
            transition: "transform 480ms cubic-bezier(0.22,1,0.36,1), opacity 480ms cubic-bezier(0.22,1,0.36,1)"
          }}>
              Our commitment
            </div>

            {}
            <h2 ref={headlineRef} className="font-default text-foreground" style={{
            fontSize: "clamp(3.5rem, 9vw, 8.5rem)",
            fontWeight: 500,
            letterSpacing: "-0.025em",
            lineHeight: 0.92,
            transform: headlineVisible ? "translateY(0)" : "translateY(12px)",
            opacity: headlineVisible ? 1 : 0,
            transition: "transform 480ms cubic-bezier(0.22,1,0.36,1) 60ms, opacity 480ms cubic-bezier(0.22,1,0.36,1) 60ms"
          }}>
              Your goals,{" "}
              <span style={{
              fontWeight: 600
            }}>achieved</span>, with precision.
            </h2>

            {}
            <div ref={hairlineRef} className="mt-14 md:mt-16 h-px w-full" style={{
            backgroundColor: "var(--border)",
            transform: hairlineVisible ? "scaleX(1)" : "scaleX(0)",
            transformOrigin: "left",
            transition: "transform 520ms ease-out 200ms"
          }} />

            {}
            <div ref={buttonRef} className="mt-10 md:mt-12 flex" style={{
            transform: buttonVisible ? "translateY(0)" : "translateY(12px)",
            opacity: buttonVisible ? 1 : 0,
            transition: "transform 480ms cubic-bezier(0.22,1,0.36,1) 240ms, opacity 480ms cubic-bezier(0.22,1,0.36,1) 240ms"
          }}>
              <Link to="/SelectYourMissionPage" className="block w-full md:w-auto">
                <Button className="group relative h-11 md:h-12 px-8 rounded-lg overflow-hidden font-default font-medium text-sm bg-primary text-primary-foreground hover:bg-primary w-full md:w-auto shadow-md" style={{
                letterSpacing: "-0.005em"
              }}>
                  <span aria-hidden="true" className="absolute inset-0 origin-left scale-x-0 group-hover:scale-x-100" style={{
                  backgroundColor: "var(--chart-2)",
                  transition: "transform 220ms cubic-bezier(0.22,1,0.36,1)"
                }} />
                  <span className="relative z-10">Explore our mission</span>
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}